export default __webpack_public_path__ + "static/media/hero-level-7-chars-desk.60a2249b.webp";